import React, {
  useCallback, useState, useEffect, useMemo,
} from 'react';
import 'antd/dist/antd.css';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setLocale } from 'yup';
import moment from 'moment';
import viVN from 'antd/lib/locale/vi_VN';
import enUS from 'antd/lib/locale/en_US';
import { ConfigProvider } from 'antd';
import AppContainer from './containers/AppContainer';
import locales from './langs/validates';
import consts from './consts';

function App() {
  const checkLanguage = window.localStorage.getItem('LANG') === 'vi' ? viVN : enUS;
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(checkLanguage);
  window.$t = t;
  window.$i18n = i18n;
  if (window.localStorage.getItem('favorites') === null) {
    const arr = [];
    window.localStorage.setItem('favorites', JSON.stringify(arr));
  }

  const changeLanguage = (lang) => {
    const event = new Event('changeLocalization', { lang });
    setLocale(locales[lang]);
    i18n.changeLanguage(lang);
    window.localStorage.setItem('LANG', lang);
    window.dispatchEvent(event);
    moment.locale(lang);
    if (lang === 'en') {
      setLanguage(enUS);
    } else {
      setLanguage(viVN);
    }
  };

  useEffect(() => {
    moment.locale(window.localStorage.getItem('LANG') || consts.VI);
    setLanguage(checkLanguage);
    setLocale(locales[window.localStorage.getItem('LANG') || consts.VI]);
  }, []);

  window.changeLanguage = changeLanguage;

  return (
    <ConfigProvider locale={language}>
      <div className="App" style={{ minWidth: '1280px', margin: 'auto' }}>
        <Router>
          <AppContainer changeLanguage={changeLanguage} />
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default App;
